import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const VEIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="VE" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#E31D1C"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          d="M7.1 4.947h.525l-.412.416.198.567-.552-.279-.491.279.14-.567-.005-.005-.408.414.197.567-.55-.278-.492.278.006-.027-.237.24.199.566-.551-.278-.112.063h.026l-.412.416.198.567-.552-.279-.49.279.14-.567-.471-.416h.615l.206-.536.242.536h.171l.087-.351-.47-.416h.615l.206-.536.241.536H5.3l.09-.364-.471-.416h.615l.206-.536.242.536h.519l-.463-.409h.615l.206-.536.241.536ZM8.879 4.925h-.524l.411.416-.198.567.552-.279.491.279-.14-.567.006-.007.41.416-.197.567.551-.278.491.278-.006-.026.237.239-.198.566.55-.278.113.063H11.4l.412.416-.198.567.552-.279.491.279-.14-.567.47-.416h-.615l-.206-.536-.241.536h-.172l-.087-.351.47-.416h-.615l-.206-.536-.24.536h-.394l-.09-.364.471-.416h-.615l-.206-.536-.242.536h-.522l.463-.409h-.614l-.206-.536-.242.536Z"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="m7.916 5.268-.49.278.14-.566-.471-.417h.614l.207-.536.241.536h.524l-.411.417.198.566-.552-.278Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
